import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { RawTransactionDto } from '@/features/dashboard/rawBankTransactions/types/RawTransactionDto.ts';
import { IgnoreTransactionRequestDto } from '@/features/dashboard/rawBankTransactions/types/BankTransactionRequests.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';

const useIgnoreTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation<
    RawTransactionDto,
    Error,
    { id: string; request?: IgnoreTransactionRequestDto }
  >({
    mutationFn: ({ id, request }) => rawBankTransactionsApi.ignore(id, request),
    onSuccess: () => {
      toast.success('Transakcja zignorowana');
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się zignorować transakcji', {
        description: error.message,
      });
    },
  });
};

export default useIgnoreTransaction;
